import React, { useState, useEffect } from 'react';
import './ProfileData.css';
import {
  DataTable,
  DataTableContent,
  DataTableHead,
  DataTableRow,
  DataTableHeadCell,
  DataTableBody,
  DataTableCell,
} from '@rmwc/data-table';
import '@rmwc/data-table/styles';
import { useFlexionStore } from './Stores';
import { getText } from './Helpers';

function ProfileData() {
  const SelectedProfile = useFlexionStore((state) => state.SelectedProfile);
  const SelectedProfileFetched = useFlexionStore((state) => state.SelectedProfileFetched);
  const Sprache = useFlexionStore((state) => state.Sprache);
  const Gewicht = useFlexionStore((state) => state.Gewicht);
  const [text, setText] = useState(getText(Sprache));

  useEffect(() => {
    setText(getText(Sprache));
  }, [Sprache]);

  return (
    <DataTable className='DataTable'>
      <DataTableContent>
        <DataTableHead>
          <DataTableRow>
            <DataTableHeadCell>Name</DataTableHeadCell>
            <DataTableHeadCell>{text.ProfileData ? text.ProfileData.Value : ''}</DataTableHeadCell>
            <DataTableHeadCell alignEnd>
              {text.ProfileData ? text.ProfileData.Unit : ''}
            </DataTableHeadCell>
          </DataTableRow>
        </DataTableHead>
        <DataTableBody>
          <DataTableRow>
            <DataTableCell>{text.ProfileData ? text.ProfileData.Area : ''}</DataTableCell>
            <DataTableCell alignEnd>
              {SelectedProfileFetched ? parseFloat(SelectedProfile.Fläche) : ''}
            </DataTableCell>
            <DataTableCell alignEnd>{SelectedProfileFetched ? 'mm²' : ''}</DataTableCell>
          </DataTableRow>
          <DataTableRow>
            <DataTableCell>Ix</DataTableCell>
            <DataTableCell alignEnd>
              {SelectedProfileFetched ? parseFloat(SelectedProfile.Ix) : ''}
            </DataTableCell>
            <DataTableCell alignEnd>{SelectedProfileFetched ? 'cm⁴' : ''}</DataTableCell>
          </DataTableRow>
          <DataTableRow>
            <DataTableCell>Iy</DataTableCell>
            <DataTableCell alignEnd>
              {SelectedProfileFetched ? parseFloat(SelectedProfile.Iy) : ''}
            </DataTableCell>
            <DataTableCell alignEnd>{SelectedProfileFetched ? 'cm⁴' : ''}</DataTableCell>
          </DataTableRow>
          <DataTableRow>
            <DataTableCell>It</DataTableCell>
            <DataTableCell alignEnd>
              {SelectedProfileFetched ? parseFloat(SelectedProfile.It) : ''}
            </DataTableCell>
            <DataTableCell alignEnd>{SelectedProfileFetched ? 'cm⁴' : ''}</DataTableCell>
          </DataTableRow>
          <DataTableRow>
            <DataTableCell>Wx</DataTableCell>
            <DataTableCell alignEnd>
              {SelectedProfileFetched ? parseFloat(SelectedProfile.Wx) : ''}
            </DataTableCell>
            <DataTableCell alignEnd>{SelectedProfileFetched ? 'cm³' : ''}</DataTableCell>
          </DataTableRow>
          <DataTableRow>
            <DataTableCell>Wy</DataTableCell>
            <DataTableCell alignEnd>
              {SelectedProfileFetched ? parseFloat(SelectedProfile.Wy) : ''}
            </DataTableCell>
            <DataTableCell alignEnd>{SelectedProfileFetched ? 'cm³' : ''}</DataTableCell>
          </DataTableRow>
          <DataTableRow>
            <DataTableCell>{text.ProfileData ? text.ProfileData.Linear : ''}</DataTableCell>
            <DataTableCell alignEnd>
              {SelectedProfileFetched ? parseFloat(SelectedProfile.Lineargewicht) : ''}
            </DataTableCell>
            <DataTableCell alignEnd>{SelectedProfileFetched ? 'g/m' : ''}</DataTableCell>
          </DataTableRow>
          <DataTableRow>
            <DataTableCell>E</DataTableCell>
            <DataTableCell alignEnd>
              {SelectedProfileFetched ? SelectedProfile.E : ''}
            </DataTableCell>
            <DataTableCell alignEnd>{SelectedProfileFetched ? 'N/mm²' : ''}</DataTableCell>
          </DataTableRow>
          <DataTableRow>
            <DataTableCell>Rp0,2</DataTableCell>
            <DataTableCell alignEnd>
              {SelectedProfileFetched ? SelectedProfile['Rp0,2'] : ''}
            </DataTableCell>
            <DataTableCell alignEnd>{SelectedProfileFetched ? 'N/mm²' : ''}</DataTableCell>
          </DataTableRow>
          <DataTableRow>
            <DataTableCell>G</DataTableCell>
            <DataTableCell alignEnd>
              {SelectedProfileFetched ? SelectedProfile.G : ''}
            </DataTableCell>
            <DataTableCell alignEnd>{SelectedProfileFetched ? 'N/mm²' : ''}</DataTableCell>
          </DataTableRow>
          <DataTableRow>
            <DataTableCell>{text.ProfileData ? text.ProfileData.Weight : ''}</DataTableCell>
            <DataTableCell alignEnd>
              {SelectedProfileFetched ? parseFloat(Gewicht) : ''}
            </DataTableCell>
            <DataTableCell alignEnd>{SelectedProfileFetched ? 'kg' : ''}</DataTableCell>
          </DataTableRow>
        </DataTableBody>
      </DataTableContent>
    </DataTable>
  );
}

export default ProfileData;
